import SigliveServiceV1 from 'Service/sigliveServiceV1';

const postForgotPassword = async ({ payload }) => {
  const { data } = await SigliveServiceV1({ method: 'POST', url: '/forgot-password', data: payload });

  return data;
};

export default postForgotPassword;
